import React from "react"
import Grid from "../../../../grid"
import { P } from "../../../../typography"
import Markdown from "../../../../markdown"

const Number = ({ label, answer }) => (
  <Grid gap="4px">
    {label && label.length > 0 && (
      <P variant="content" marginless profileLabel>
        {label}
      </P>
    )}
    {answer && <Markdown>{answer}</Markdown>}
    {!answer && (
      <P marginless profileData>
        -
      </P>
    )}
  </Grid>
)

export default Number
